// Mock data for percentage data

export const MockPCTData = [
    { date: "2025-08-02", previous: 3.2, forecast: 3.1, actual: 3.0 },
    { date: "2025-07-02", previous: 3.4, forecast: 3.3, actual: 3.2 },
    { date: "2025-06-02", previous: 3.6, forecast: 3.5, actual: 3.4 },
    { date: "2025-05-02", previous: 3.8, forecast: 3.7, actual: 3.6 },
    { date: "2025-04-02", previous: 4.0, forecast: 3.9, actual: 3.8 },
    { date: "2025-03-02", previous: 4.1, forecast: 4.0, actual: 4.0 },
    { date: "2025-02-02", previous: 4.2, forecast: 4.1, actual: 4.1 },
    { date: "2025-01-02", previous: 4.3, forecast: 4.2, actual: 4.2 },
    { date: "2024-12-02", previous: 4.5, forecast: 4.4, actual: 4.3 },
    { date: "2024-11-02", previous: 4.7, forecast: 4.6, actual: 4.5 },
    { date: "2024-10-02", previous: 4.8, forecast: 4.7, actual: 4.7 },
    { date: "2024-09-02", previous: 5.0, forecast: 4.9, actual: 4.8 },
    { date: "2024-08-02", previous: 5.2, forecast: 5.1, actual: 5.0 },
    { date: "2024-07-02", previous: 5.4, forecast: 5.3, actual: 5.2 },
    { date: "2024-06-02", previous: 5.6, forecast: 5.5, actual: 5.4 },
    { date: "2024-05-02", previous: 5.8, forecast: 5.7, actual: 5.6 },
    { date: "2024-04-02", previous: 6.0, forecast: 5.9, actual: 5.8 },
    { date: "2024-03-02", previous: 6.3, forecast: 6.1, actual: 6.0 },
    { date: "2024-02-02", previous: 6.5, forecast: 6.3, actual: 6.3 },
    { date: "2024-01-02", previous: 6.7, forecast: 6.5, actual: 6.5 },
    { date: "2023-12-02", previous: 6.9, forecast: 6.7, actual: 6.7 },
    { date: "2023-11-02", previous: 7.0, forecast: 6.9, actual: 6.8 },
    { date: "2023-10-02", previous: 7.2, forecast: 7.1, actual: 7.0 },
    { date: "2023-09-02", previous: 7.4, forecast: 7.3, actual: 7.2 },
    { date: "2023-08-02", previous: 7.6, forecast: 7.5, actual: 7.4 }
];

export default MockPCTData;
